module.exports = __webpack_public_path__ + "static/media/Steuerberater_Handout_2025.06c5e028.pdf";